import { downloadCSV } from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";

const exporter = (enterprises) => {
  const data = enterprises.map((enterprise) => ({
    id: enterprise.id,
    cnpj: enterprise.register_number,
    nome: enterprise.name,
    criado_em: enterprise.created_at_format
  }));
  const csv = convertToCSV({
    data,
    fields: ["id", "cnpj", "nome", "criado_em"]
  });
  downloadCSV(csv, "enterprises");
};

export default exporter;
